/**
 * What the old store is called, and where its home is. While the new Arche
 * Store is switched off the old store IS the Arche Store (`/marketplace`); once
 * it is on, the old one is the Advanced search (`/marketplace/browse`) — the
 * more functional search, kept beside the new store (owner decision
 * 2026-10-30).
 */
import { useStorePageAvailable } from '@/lib/store-availability';

export function useOldStoreName(): { name: string; homePath: string; newStoreShown: boolean } {
  const newStoreShown = useStorePageAvailable() === true;
  return newStoreShown
    ? { name: 'Advanced search', homePath: '/marketplace/browse', newStoreShown }
    : { name: 'Arche Store', homePath: '/marketplace', newStoreShown };
}
